/**
 * How much the merchant may ask in one turn (MAR-173 PR 3).
 *
 * merchant-chat answers **400** for a message over `MAX_MESSAGE_CHARS`
 * (`services/chat/merchant-chat/src/history-store.js`), with the body
 * `{ success:false, error, code:'message_too_long', maxChars }`. The dock caps
 * the composer at the same number so that the refusal is a backstop, not the
 * merchant's first news of the limit. `capabilityParity.test.ts` pins this
 * copy against the server's.
 *
 * Dependency-free on purpose: `useAskThread` and `AskDock` both read it.
 */
export const MAX_MESSAGE_CHARS = 4000

/** The counter appears from here, so the limit is visible before it bites. */
export const COUNT_FROM_CHARS = 3500

/** The server's stable token for this refusal. `error` is prose and is not matched. */
export const MESSAGE_TOO_LONG = 'message_too_long'

const formatChars = (n: number) => n.toLocaleString('en-GB')

/**
 * What the transcript says when the server refused a turn for length. Retrying
 * can never fix this, so it must not read like `UNREACHABLE`.
 */
export const tooLongCopy = (maxChars: number = MAX_MESSAGE_CHARS) =>
  `That message is too long — Marva can read up to ${formatChars(maxChars)} characters at once. Try trimming it.`

/** Shown under the composer when a paste was cut to fit. */
export const clippedCopy = (maxChars: number = MAX_MESSAGE_CHARS) =>
  `Your paste was cut to ${formatChars(maxChars)} characters, the most Marva can read at once.`

export const countCopy = (length: number, maxChars: number = MAX_MESSAGE_CHARS) =>
  `${formatChars(length)} / ${formatChars(maxChars)}`
